// @flow

import styled from 'styled-components';
import {
  ml, mr, px, py
} from 'styled-components-spacing';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import theme from '@theme';

export const StyledCover = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  ${px(3)}
  ${py(3)}

  background-color: ${theme.colors.greyBlue10};
`;

export const StyledContent = styled.p`
  flex: 1;
  font-size: 14px;
  font-weight: normal;
  color: ${theme.colors.darkBlue};
`;

export const StyledTitle = styled.span`
  display: inline-block;
  ${mr(1)}
`;

export const StyledFilter = styled.span`
  font-weight: bold;

  &:not(:last-child)::after {
    content: ',';
    display: inline-block;
    ${mr(1)}
  }
`;

export const StyledIcon = styled(FontAwesomeIcon)`
  font-size: 16px;
  line-height: 16px;
  height: 16px;
  color: ${theme.colors.formSeparator};

  ${ml(3)}
`;
